<app-avatar
  [me]="data.me"
  [firstName]="data.firstName"
  [lastName]="data.lastName"
></app-avatar>
